var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSepolia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.6199C17.16 21.6199 21.36 17.4399 21.36 12.2799C21.36 7.11994 17.16 2.93994 12 2.93994C6.84001 2.93994 2.64001 7.11994 2.64001 12.2799C2.64001 17.4399 6.84001 21.6199 12 21.6199Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.54C20.2 15.46 24 15.02 24 12.38C24 9.74001 21 9.56001 12 9.14001C3 9.56001 0 9.74001 0 12.38C0 15.02 3.8 15.46 12 15.54Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.59998C16.88 3.59998 20.84 7.47998 20.84 12.26C20.84 17.04 16.86 20.92 12 20.92C7.14003 20.92 3.16003 17.04 3.16003 12.26C3.16003 7.47998 7.12003 3.59998 12 3.59998ZM12 4.15998C7.50003 4.15998 3.88003 7.77998 3.88003 12.26C3.88003 16.74 7.52003 20.36 12 20.36C16.48 20.36 20.12 16.74 20.12 12.26C20.12 7.77998 16.48 4.15998 12 4.15998Z",
    fill: "url(#paint0_linear_704_347)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.02 3.97998C16.58 3.97998 20.28 7.67998 20.28 12.22C20.28 16.76 16.58 20.46 12.02 20.46C7.45999 20.46 3.73999 16.78 3.73999 12.22C3.73999 7.65998 7.43999 3.97998 12.02 3.97998ZM12.02 4.15998C7.51999 4.15998 3.89999 7.77998 3.89999 12.26C3.89999 16.74 7.53999 20.36 12.02 20.36C16.5 20.36 20.14 16.74 20.14 12.26C20.14 7.77998 16.5 4.15998 12.02 4.15998Z",
    fill: "#FCD0A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.59998C16.88 3.59998 20.84 7.47998 20.84 12.26C20.84 17.04 16.86 20.92 12 20.92C7.14003 20.92 3.16003 17.04 3.16003 12.26C3.16003 7.47998 7.12003 3.59998 12 3.59998ZM12 4.15998C7.50003 4.15998 3.88003 7.77998 3.88003 12.26C3.88003 16.74 7.52003 20.36 12 20.36C16.48 20.36 20.12 16.74 20.12 12.26C20.12 7.77998 16.48 4.15998 12 4.15998Z",
    fill: "url(#paint1_linear_704_347)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.02 3.90002C16.64 3.90002 20.38 7.64002 20.38 12.26C20.38 16.88 16.64 20.62 12.02 20.62C7.40001 20.62 3.64001 16.88 3.64001 12.26C3.64001 7.64002 7.38001 3.90002 12.02 3.90002ZM12.02 3.98002C7.42001 3.98002 3.70001 7.68002 3.70001 12.26C3.70001 16.84 7.42001 20.54 12 20.54C16.58 20.54 20.3 16.84 20.3 12.26C20.3 7.68002 16.6 3.98002 12.02 3.98002Z",
    fill: "#FCD0A9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.59998C16.88 3.59998 20.84 7.47998 20.84 12.26C20.84 17.04 16.86 20.92 12 20.92C7.14003 20.92 3.16003 17.04 3.16003 12.26C3.16003 7.47998 7.12003 3.59998 12 3.59998ZM12 4.15998C7.50003 4.15998 3.88003 7.77998 3.88003 12.26C3.88003 16.74 7.52003 20.36 12 20.36C16.48 20.36 20.12 16.74 20.12 12.26C20.12 7.77998 16.48 4.15998 12 4.15998Z",
    fill: "url(#paint2_linear_704_347)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28003 11.66C3.28003 16.46 7.18003 20.36 12 20.36C16.82 20.36 20.72 16.46 20.72 11.66C20.72 11.24 20.68 10.82 20.64 10.42C20.78 11.02 20.84 11.64 20.84 12.28C20.84 17.06 16.88 20.94 12 20.94C7.12003 20.94 3.16003 17.04 3.16003 12.26C3.16003 11.62 3.22003 11 3.36003 10.4C3.30003 10.82 3.28003 11.22 3.28003 11.66Z",
    fill: "url(#paint3_linear_704_347)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.59998C16.88 3.59998 20.84 7.47998 20.84 12.26C20.84 12.92 20.76 13.56 20.62 14.18C20.7 13.74 20.72 13.28 20.72 12.82C20.72 8.01998 16.82 4.11998 12 4.11998C7.18003 4.11998 3.28003 8.01998 3.28003 12.82C3.28003 13.28 3.32003 13.74 3.38003 14.18C3.24003 13.56 3.16003 12.92 3.16003 12.26C3.16003 7.47998 7.12003 3.59998 12 3.59998Z",
    fill: "url(#paint4_linear_704_347)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.12C19.84 15.04 23.48 14.66 23.48 12.3C23.48 9.94002 20.6 9.78002 12 9.40002C3.40002 9.78002 0.52002 9.94002 0.52002 12.3C0.52002 14.66 4.14002 15.04 12 15.12Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10004 9.64001V9.70001C2.70004 10.22 1.68004 11.06 1.68004 12.3C1.68004 13.5 3.08004 14.5 7.12004 14.94V15C2.64004 14.74 0.540039 14.08 0.540039 12.3C0.540039 10.46 2.28004 9.96001 7.10004 9.64001ZM16.92 9.64001C21.74 9.96001 23.48 10.46 23.48 12.3C23.48 14.1 21.38 14.74 16.92 15V14.94C20.94 14.5 22.36 13.5 22.36 12.3C22.36 11.06 21.32 10.22 16.92 9.72001V9.64001Z",
    fill: "url(#paint5_linear_704_347)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08004 9.66003V9.72003C2.68004 10.22 1.66004 11.06 1.66004 12.3C1.66004 13.5 3.06004 14.5 7.10004 14.94V14.98C3.02004 14.72 1.10004 14.06 1.10004 12.3C1.08004 10.5 2.68004 9.98003 7.08004 9.66003ZM16.9 9.66003C21.3 9.98003 22.9 10.5 22.9 12.3C22.9 14.06 20.98 14.72 16.9 14.98V14.94C20.92 14.5 22.34 13.5 22.34 12.3C22.34 11.06 21.3 10.22 16.9 9.72003V9.66003Z",
    fill: "url(#paint6_linear_704_347)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10006 9.66003C2.72006 9.98003 1.14006 10.5 1.14006 12.3C1.14006 14.06 3.04006 14.72 7.10006 14.98C3.00006 14.72 1.06006 14.06 1.06006 12.3C1.06006 10.5 2.68006 9.98003 7.10006 9.66003ZM16.9201 9.66003C21.3601 9.98003 22.9601 10.5 22.9601 12.3C22.9601 14.06 21.0201 14.72 16.9201 14.98C20.9801 14.72 22.8801 14.06 22.8801 12.3C22.8601 10.5 21.2801 9.98003 16.9201 9.66003Z",
    fill: "#FFECDC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 1.59998L12.9601 8.59998C13.0601 9.39998 13.6001 10.08 14.3401 10.38L15.9401 11.04C14.7801 10.98 13.4801 10.92 12.0001 10.86C10.5201 10.92 9.22006 10.98 8.06006 11.04L9.66006 10.38C10.4001 10.08 10.9201 9.39998 11.0401 8.59998L12.0001 1.59998Z",
    fill: "url(#paint7_linear_704_347)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 1.59998L12.9601 8.59998C13.0601 9.39998 13.6001 10.08 14.3401 10.38L15.9401 11.04C15.5201 11.02 15.1001 11 14.6401 10.98L14.0601 10.76C13.2601 10.46 12.7001 9.71998 12.6201 8.85998L12.0001 1.97998L11.3801 8.85998C11.3001 9.71998 10.7401 10.46 9.94006 10.76L9.38006 10.98C8.90006 11 8.48006 11.02 8.06006 11.04L9.66006 10.38C10.4001 10.08 10.9201 9.39998 11.0401 8.59998L12.0001 1.59998Z",
    fill: "url(#paint8_linear_704_347)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.57996L12.38 9.85996C12.46 10.36 12.86 10.74 13.36 10.8L15.12 11.02C14.64 11 14.14 10.98 13.6 10.94L12.84 10.86C12.48 10.82 12.2 10.54 12.16 10.18L12 8.33996L11.84 10.18C11.8 10.54 11.52 10.82 11.16 10.86L10.4 10.94C9.85999 10.96 9.33999 10.98 8.85999 11L10.62 10.78C11.12 10.72 11.52 10.34 11.6 9.83996L12 7.57996Z",
    fill: "url(#paint9_linear_704_347)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.02 8.33997L12.18 10.18C12.22 10.54 12.5 10.82 12.86 10.86L13.62 10.94C13.1 10.92 12.56 10.9 12 10.86C11.44 10.88 10.9 10.9 10.38 10.94L11.14 10.86C11.5 10.82 11.78 10.54 11.82 10.18L12.02 8.33997Z",
    fill: "url(#paint10_linear_704_347)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.06 7.19995L12.52 9.81995C12.6 10.3 12.98 10.66 13.44 10.74L13.86 10.82L13.44 10.76C12.94 10.7 12.54 10.32 12.42 9.83995V9.79995L12.06 7.95995L11.72 9.77995C11.62 10.3 11.2 10.7 10.68 10.76L10.14 10.82L10.66 10.74C11.14 10.66 11.5 10.3 11.58 9.81995L12.06 7.19995Z",
    fill: "url(#paint11_linear_704_347)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.18 5.83997L12.64 8.93997C12.76 9.71997 13.26 10.36 13.98 10.68L14.54 10.92L14 10.72C13.76 10.62 13.54 10.5 13.34 10.34C12.92 9.97997 12.64 9.47997 12.56 8.89997L12.18 5.83997ZM11.84 5.83997L11.44 8.89997C11.36 9.45997 11.08 9.97997 10.66 10.34C10.46 10.5 10.24 10.62 9.99996 10.72L9.45996 10.92L10.02 10.68C10.74 10.36 11.24 9.71997 11.36 8.93997L11.84 5.83997Z",
    fill: "#FFECDC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.61997L11.92 4.61998L12 1.59998L12.08 4.61998L12 7.61997Z",
    fill: "#FFECDC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.59998L11.14 9.19998L12 2.27998L12.86 9.19998L12 1.59998Z",
    fill: "#FFECDC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.64 12.86L19.68 12.9C19.68 12.9 19.68 12.9 19.7 12.9C19.7 13 18 13.16 14.62 13.36C13.66 13.42 12.9 14.2 12.84 15.16C12.7 18.02 12.42 20.4 12 22.3C11.58 20.44 11.32 18.14 11.16 15.36L11.14 15.16C11.1 14.2 10.32 13.42 9.36005 13.36C6.00005 13.16 4.30005 13 4.30005 12.88H4.32005C5.38005 11.86 8.36005 11.44 11.88 11.42H12C15.54 11.42 18.54 11.84 19.64 12.86Z",
    fill: "url(#paint12_linear_704_347)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.64 12.86L19.68 12.9C19.68 12.9 19.68 12.9 19.7 12.9C19.7 13.02 17.8 13.14 14 13.26C13.18 13.28 12.54 13.96 12.54 14.76C12.54 17.82 12.36 20.34 12 22.3C11.66 20.38 11.48 17.94 11.46 14.96V14.76C11.46 13.94 10.82 13.28 10 13.26C6.20005 13.12 4.30005 13 4.30005 12.88H4.32005C5.38005 11.86 8.36005 11.44 11.88 11.42H12C15.54 11.42 18.54 11.84 19.64 12.86Z",
    fill: "url(#paint13_linear_704_347)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.34L11.92 11.98H12.08L12 22.34Z",
    fill: "#FFECDC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30005 12.9C4.42005 13 6.34005 13.12 10.08 13.22C10.9 13.24 11.56 13.92 11.54 14.76V14.96C11.5 17.94 11.66 20.38 12 22.3C12.34 20.34 12.5 17.84 12.46 14.76C12.44 13.92 13.1 13.24 13.92 13.22H14.04C17.74 13.12 19.62 13 19.7 12.9C19.58 13 17.68 13.12 14 13.26C13.18 13.28 12.54 13.96 12.54 14.78C12.54 14.92 12.54 15.06 12.54 15.2V15.5C12.54 16.56 12.54 17.28 12.52 17.66C12.44 19.46 12.24 21 12.02 22.32C11.78 21.02 11.6 19.46 11.52 17.66C11.5 17.28 11.5 16.56 11.5 15.5V15.2C11.5 15.1 11.5 15 11.5 14.88V14.78C11.5 13.96 10.86 13.3 10.04 13.26C6.28005 13.12 4.38005 13 4.30005 12.9Z",
    fill: "#FFECDC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.42C15.58 11.42 18.6 11.86 19.68 12.88H19.64C18.52 12.24 15.52 11.98 12 11.98C8.48005 11.98 5.48005 12.26 4.36005 12.88H4.30005C5.40005 11.86 8.44005 11.42 12 11.42Z",
    fill: "url(#paint14_linear_704_347)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1399 11.9C15.4999 11.9 18.3799 12.16 19.5599 12.76C19.6199 12.8 19.6599 12.84 19.6999 12.88H19.6599C18.5599 12.26 15.6199 11.98 12.1399 11.98H11.9999C8.49995 11.98 5.49995 12.26 4.37995 12.88H4.31995C4.35995 12.84 4.41995 12.8 4.45995 12.76C5.65995 12.16 8.57995 11.9 11.9999 11.9H12.1399Z",
    fill: "#FFECDC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.68 12.88H19.64C19.6 12.86 19.58 12.84 19.54 12.82C18.34 11.88 15.42 11.48 12 11.48C8.58005 11.48 5.64005 11.88 4.46005 12.82C4.42005 12.86 4.38005 12.86 4.36005 12.88H4.30005C5.38005 11.86 8.36005 11.44 11.88 11.42H12C15.58 11.42 18.6 11.86 19.68 12.88Z",
    fill: "#FFECDC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_704_347",
    x1: 12,
    y1: 3.59996,
    x2: 12,
    y2: 20.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_704_347",
    x1: 12,
    y1: 17.2068,
    x2: 12,
    y2: 9.19488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_704_347",
    x1: 12,
    y1: 17.2068,
    x2: 12,
    y2: 9.57056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3293
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_704_347",
    x1: 15.103,
    y1: 15.67,
    x2: 8.83529,
    y2: 15.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_704_347",
    x1: 13.593,
    y1: 8.88996,
    x2: 10.3435,
    y2: 8.88996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_704_347",
    x1: 12,
    y1: 9.64003,
    x2: 12,
    y2: 14.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_704_347",
    x1: 12,
    y1: 14.98,
    x2: 12,
    y2: 9.66747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_704_347",
    x1: 12.0001,
    y1: 1.59998,
    x2: 12.0001,
    y2: 10.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD8B42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6A56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#815229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_704_347",
    x1: 12.0001,
    y1: 11.04,
    x2: 12.0001,
    y2: 1.59998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_704_347",
    x1: 12,
    y1: 7.58512,
    x2: 12,
    y2: 10.9804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A96121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_704_347",
    x1: 12,
    y1: 8.33999,
    x2: 12,
    y2: 10.9158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B683A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_704_347",
    x1: 12,
    y1: 7.20745,
    x2: 12,
    y2: 10.8275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD905A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_704_347",
    x1: 12,
    y1: 11.4226,
    x2: 12,
    y2: 22.2251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C75E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C9976B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_704_347",
    x1: 12,
    y1: 11.4226,
    x2: 12,
    y2: 22.3026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FCAF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EEBE95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_704_347",
    x1: 4.31005,
    y1: 12.1526,
    x2: 19.69,
    y2: 12.1526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA8031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFECDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8031"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepolia);
export default __webpack_public_path__ + "static/media/sepolia.9f7b09ac33b1dba0dde1cbf8b2dbb93e.svg";
export { ForwardRef as ReactComponent };